import { Box, TextField, Typography, Autocomplete, Dialog, DialogActions, DialogContent, DialogTitle, Button } from "@mui/material";
import logo from '../images/EUMAK.png';
import VoiceSearch from "./VoiceSearch";
import { useEffect, useState } from "react";
import axios from "axios";

const Navbar = () => {
    const [inputValue, setInputValue] = useState('');
    const [options, setOptions] = useState([]);
    const [selectedSong, setSelectedSong] = useState(null);
    const [songUrl, setSongUrl] = useState(null); // State to store the song URL
    const [openDialog, setOpenDialog] = useState(false); // State to handle Dialog visibility

    // Fetch song suggestions based on the search input
    useEffect(() => {
        const fetchSuggestions = async () => {
            if (inputValue.length < 3) {
                setOptions([]);
                return;
            }

            try {
                const response = await axios.get(`https://music-endpoint.onrender.com/songs/search?keyword=${inputValue}`);
                if (response.status === 200 && response.data.data) {
                    const songList = response.data.data.map(song => song.songName);
                    setOptions(songList);
                }
            } catch (error) {
                console.error("Error fetching song suggestions:", error);
            }
        };

        const delayDebounce = setTimeout(() => {
            fetchSuggestions();
        }, 300); // debounce to limit API calls

        return () => clearTimeout(delayDebounce);
    }, [inputValue]);

    // Handle song selection and fetch the song details (URL) to play
    const handleSelection = async (event, newValue) => {
        setSelectedSong(newValue);
        console.log("Selected song:", newValue);

        if (newValue) {
            try {
                const response = await axios.get(`https://music-endpoint.onrender.com/play/${encodeURIComponent(newValue)}`, {
                    responseType: 'blob', // To handle binary data (audio)
                });


                if (response.status === 200) {
                    const songUrl = URL.createObjectURL(response.data);
                    setSongUrl(songUrl);
                    setOpenDialog(true);
                }
            } catch (error) {
                console.error("Error fetching song stream:", error);
                if (error.response) {
                    console.error("Response error:", error.response); // Log the full response if available
                }
            }
        }
    };


    // Close the dialog
    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    return (
        <>
            <Box>
                <Box sx={{
                    display: "flex",
                    height: "9vh",
                    marginBottom: 2,
                    textIndent: "20px",
                    justifyContent: "space-evenly",
                    padding: "10px",
                    background: "#121212",
                    color: "#F0F3F5"
                }}>
                    <Box sx={{ display: "flex", alignItems: "center", paddingRight: "20px" }}>
                        <h2>Welcome, User!</h2>
                    </Box>

                    <VoiceSearch />

                    <Autocomplete
                        freeSolo
                        options={options}
                        onInputChange={(e, value) => setInputValue(value)}
                        onChange={handleSelection}
                        sx={{ marginTop: "10px", width: "400px", height: "50px" }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                placeholder="Search for a song..."
                                sx={{
                                    backgroundColor: "whitesmoke",
                                    borderRadius: "50px",
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            border: 'none',
                                        },
                                        '&:hover fieldset': {
                                            border: 'none',
                                        },
                                        '&.Mui-focused fieldset': {
                                            border: 'none',
                                        },
                                    },
                                    '& .MuiOutlinedInput-root.Mui-focused': {
                                        boxShadow: 'none',
                                    }
                                }}
                            />
                        )}
                    />

                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <h1>My Music App</h1>
                        <img
                            src={logo}
                            alt="Logo"
                            style={{
                                width: "120px",
                                height: "150px",
                                paddingTop: "10px",
                                marginLeft: "10px"
                            }}
                        />
                    </Box>
                </Box>
            </Box>

            {selectedSong && (
                <Box sx={{
                    backgroundColor: "#1e1e1e",
                    padding: "12px",
                    borderRadius: "10px",
                    margin: "16px auto",
                    textAlign: "center",
                    width: "fit-content",
                    color: "#F0F3F5",
                    boxShadow: "0px 0px 10px rgba(255, 255, 255, 0.1)"
                }}>
                    <Typography variant="h6">
                        🎵 Now Viewing: <strong>{selectedSong}</strong>
                    </Typography>
                </Box>
            )}

            {/* Dialog for the audio player */}
            <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
                <DialogTitle>
                    Now Playing: <strong>{selectedSong}</strong>
                </DialogTitle>
                <DialogContent sx={{ display: "flex", justifyContent: "center", padding: 2 }}>
                    {songUrl ? (
                        <audio controls autoPlay>
                            <source src={songUrl} type="audio/mpeg" />
                            Your browser does not support the audio element.
                        </audio>
                    ) : (
                        <Typography variant="body1">Loading song...</Typography>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} color="primary">Close</Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default Navbar;
